export default "__VITE_ASSET__e48933b0__"